// @ts-nocheck

import { type Selector } from '../types/selectors';
import isHome from '../utils/routes/isHome';

import { selectIsAnyOperationRunning } from './operations.selector';

// no-memoize
export const selectAreBigBoostedOddsCompact: Selector<boolean> = (
  state: StateType,
  { pathname }: { pathname: string } | undefined = {},
) => isHome(pathname) && selectIsAnyOperationRunning(state);
